<template>
  <div>
    <PageTitle
      title="Shops"
      :btnCreate="true"
      @onClickCreate="AddShop()"
      :createPopup="true"
      :permission="'Shop Create'"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-btn :ripple="false" class="min-button" icon @click="show = !show">
          <v-icon color="blue" class="ml-10">
            {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
          </v-icon>
          <span class="subheading filterclor">Filter</span>
        </v-btn>
        <v-expand-transition>
          <v-card class="lighten-12 card-content mb-2" v-show="show">
            <v-row class="ma-0 align-right">
              <TableFilters
                :filters="['status', 'search']"
                v-model="filter"
                :columns="columns"
                :msgs="'Name'"
              ></TableFilters>
              <ImportExportMenu :permission="'Unit Report'"></ImportExportMenu>
            </v-row>
          </v-card>
        </v-expand-transition>

        <LoadingComponent
          v-if="isLoading"
          :visible="isLoading"
        ></LoadingComponent>
        <v-card class="lighten-12 mt-2">
          <v-container class="light gray lighten-12" fluid>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                @click:row="$router.push(`shop/${$event.id}`)"
                class="row-pointer"
                :items="shops"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                show-expand
                item-key="id"
                hide-default-footer
                style="font-family: 'Source Sans Pro', sans-serif"
              >
                <template v-slot:no-data>
                  <noData
                    class="mt-16 container justify-center item-center"
                    name="shop"
                  />
                </template>
                <!-- <template v-slot:item.name="{ item }">
                  <div class="p-100">{{ item }}</div>
                </template> -->

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="px-5">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="6"
                        v-if="item.contact.length"
                      >
                        <v-card class="lighten-12">
                          <v-card-title class="v-card__title saletiltle"
                            ><v-icon small color="blue">mdi-contacts</v-icon
                            ><span class="pl-3"> Contact</span>
                          </v-card-title>
                          <v-container fluid class="container saledetailscard">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                class="pt-0 sub-section"
                                v-for="item in item.contact"
                                :key="item"
                              >
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Telephone
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    <a
                                      href=""
                                      :style="
                                        item.telephone && item.telephone
                                          ? { color: 'blue' }
                                          : { 'text-decoration': 'none' }
                                      "
                                    >
                                      {{
                                        item.telephone ? item.telephone : '---'
                                      }}</a
                                    >
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Phone
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    <a
                                      href=""
                                      :style="
                                        item.phone && item.phone
                                          ? { color: 'light-blue' }
                                          : { 'text-decoration': 'none' }
                                      "
                                    >
                                      {{ item.phone ? item.phone : '---' }}</a
                                    >
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Email
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{ item.email ? item.email : '---' }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Contactable Type
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.contactable_type
                                        ? item.contactable_type
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="6"
                        v-if="item.address.length"
                      >
                        <v-card class="lighten-12">
                          <v-card-title class="v-card__title saletiltle"
                            ><v-icon color="blue" small>mdi-city</v-icon
                            ><span class="pl-3"> Address</span>
                          </v-card-title>
                          <v-container fluid class="container saledetailscard">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                class="pt-0 sub-section"
                                v-for="item in item.address"
                                :key="item"
                              >
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Address Line 1
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.address_line1
                                        ? item.address_line1
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Address Line 2
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.address_line2
                                        ? item.address_line2
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    City
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{ item.city ? item.city : '---' }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Postal Code
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.postal_code
                                        ? item.postal_code
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Country
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.country ? item.country.name : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                    </v-row>
                    <template
                      v-if="
                        item.contact.length == 0 && item.address.length == 0
                      "
                    >
                      <v-card>
                        <v-container fluid> No Contacts & Address</v-container>
                      </v-card></template
                    >
                  </td>
                </template>

                <!-- Shop Name -->
                <template v-slot:item.name="{ item }" :slot-scope="props">
                  <div class="shop-name tbl-data">
                    <v-tooltip top color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="ma-2"
                          color="grey lighten-1"
                          small
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >mdi-information</v-icon
                        >
                      </template>
                      <span>{{ item.name ? item.name : '...........' }}</span>
                    </v-tooltip>
                    {{ item.name ? item.name : '...........' }}
                  </div>
                </template>

                <!-- Status -->
                <template v-slot:item.is_active="{ item }" :slot-scope="props">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    style="font-weight: 800; font-variant-caps: all-small-caps"
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                  >
                </template>

                <template v-slot:item.sortform="{ item }" :slot-scope="props">
                  <div class="tbl-data">
                    {{ item.sortform ? item.sortform : '............' }}
                  </div>
                </template>

                <template
                  v-slot:item.account.nick_name="{ item }"
                  :slot-scope="props"
                >
                  <div class="tbl-data">
                    {{
                      item.account.nick_name
                        ? item.account.nick_name
                        : '..........'
                    }}
                  </div>
                </template>

                <template
                  v-slot:item.account.available_balance="{ item }"
                  :slot-scope="props"
                >
                  <div>
                    <v-chip label text-color="white" color="primary" dark
                      >LKR
                      {{
                        item.account.available_balance
                          ? item.account.available_balance
                          : '...........' | formatCurrency
                      }}
                    </v-chip>
                  </div>
                </template>

                <template
                  v-slot:item.account.opened_date="{ item }"
                  v-slot="{ errors }"
                  name="value"
                  rules="numeric"
                  ><div>
                    {{
                      item.account.opened_date
                        ? item.account.opened_date
                        : '..........' | formatDate
                    }}
                  </div></template
                >

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="shop"
                    :item="item"
                    viewPermission="Shop Show"
                    editPermission="Shop Edit"
                    softDeletePermission="Shop Soft Delete"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>
                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    @getPageNumber="setPagenumber"
                    :filterAction="true"
                    url="shops"
                    ref="refer"
                    :filter="filter"
                  >
                  </pagination>
                </template>
              </v-data-table>
            </v-card-text>
          </v-container>
        </v-card>
      </ValidationObserver>

      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import EditShop from './EditShopComponent';
import CreateShop from './CreateShopComonent';
import { required, email, max, regex } from 'vee-validate/dist/rules';
import { mapState } from 'vuex';
import pagination from '../../../components/pagination';
import confirmation from '../../../components/confirmation';
import noData from '../../../../../components/shared/noItem';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});
extend('regex', {
  ...regex,
  message: 'The value is not a valid phone number',
});
export default {
  components: {
    pagination,
    ValidationProvider,
    TableFilters,
    ValidationObserver,
    noData,
  },
  data() {
    return {
      show: false,
      paginationOptions: {},
      contactValueS: [
        { email: 'aaa@aa.com', telephone: '0212221212', phone: '0212221212' },
      ],
      isLoading: false,
      expanded: [],
      singleExpand: false,
      progressBar: false,

      pagination1: {
        descending: true,
        page: 1,
        rowsPerPage: 2,
        sortBy: 'fat',
        totalItems: 0,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      addressHeaders: [
        {
          text: 'Address Line1',
          value: 'address_line1',
          show: true,
          align: 'left',
          disabled: false,
        },
        {
          text: 'Address Line2',
          value: 'address_line2',
          show: true,
          align: 'left',
          disabled: false,
        },
        {
          text: 'City',
          value: 'city',
          align: 'left',
          show: true,
          disabled: false,
        },
        {
          text: 'Country',
          value: 'country.name',
          align: 'left',
          show: true,
          disabled: false,
        },
        {
          text: 'Postal Code',
          value: 'postal_code',
          align: 'left',
          show: true,
          disabled: false,
        },
      ],
      contactHeaders: [
        { text: 'Phone', value: 'phone', align: 'left' },
        { text: 'Telephone', value: 'telephone', align: 'left' },
        { text: 'Email', value: 'email', align: 'left' },
      ],
      stockcolumns: [
        {
          text: 'Product',
          value: 'product.name',
        },
        { text: 'Unit', value: 'unit.name' },

        {
          text: ' Actual stock',
          value: 'available_stock',
          align: 'center',
        },
        {
          text: 'Damage',
          value: 'damage',
          align: 'center',
        },
        {
          text: 'Reorder Level',
          value: 'reorder_level',

          align: 'center',
        },
      ],
      shopsdata: {},
      shops: [],
      stockshops: [],
      isCreateFormVisible: false,
      isEditFormVisible: false,
      pagination: {
        page: 1,
        itemsPerPage: 2,
      },
      page: 1,
      status: [
        { text: 'Active', value: 'active' },
        { text: 'Archived', value: 'archived' },
      ],
      columns: [
        {
          text: 'Name',
          value: 'name',
          show: true,
          align: 'left',
          disabled: false,
        },
        {
          text: 'Short form',
          value: 'sortform',
          show: true,
          align: 'center',
          disabled: false,
        },

        // {
        //   text: "Account nick name",
        //   value: "account.nick_name",
        //   show: true,
        //   align: "center",
        //   disabled: false,
        // },
        {
          text: 'Account open date',
          value: 'account.opened_date',
          show: true,
          align: 'center',
          disabled: false,
        },
        {
          text: 'Account available balance',
          value: 'account.available_balance',
          show: true,
          align: 'center',
          disabled: false,
        },

        {
          text: 'Status',
          value: 'is_active',
          show: true,
          disabled: false,
          align: 'center',
        },
        {
          text: 'Actions',
          value: 'action',
          show: true,
          disabled: false,
          align: 'center',
          sortable: false,
        },
      ],
      contacts: [],
      addresses: [],
      filter: {
        name: '',
        search: '',
        status: '',
      },
    };
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    filterContact(data) {
      return data.map((item) => {
        return {
          email: item.email,
          telephone: item.telephone,
          phone: item.phone,
        };
      });
    },
    ViewShop(item) {
      this.$router.push(`/shop/${item.id}`);
    },
    EditShop(item) {
      this.$router.push(`/shop/edit/${item.id}`);
    },

    openConfirmation(shops) {
      confirmation.dialog = true;
      this.$confirm(
        'Do you want to ' + (shops.is_active ? 'Archive' : 'Activate  ') + '?',
      ).then((res) => {
        if (res) {
          this.ArchiveOrActiveShop(shops);
        }
      });
    },
    ArchiveOrActiveShop(shops) {
      this.$store
        .dispatch('shop/ArchiveOrActiceShop', shops.id)
        .then((res) => {
          shops.is_active = !shops.is_active;

          const msg = shops.is_active ? 'activated' : 'archived';

          this.$toast.success('Successfully ' + msg);
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },

    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
    AddShop() {
      this.$router.push(`/shop/add`);
    },
    refreshData() {
      this.$refs.refer.refreshData();
    },
    setResponseData(shop) {
      let self = this;
      self.shops = [];
      shop.forEach((element) => {
        element.contact = element.contact == null ? [] : [element.contact];
        element.address = element.address == null ? [] : [element.address];
        self.shops.push(element);
      });

      // this.warehouses = shop;

      // this.contacts= contacts.map(i=>{push(shop.contact)});
      // this.addresses= addresses.push(shop.address);
    },
  },
  mounted: function () {
    this.refreshData();
    // this.GetShopSingle();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.shop-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 150px;
}
.tbl-data {
  /* font-weight: bold; */
}
.address-container {
  display: flex;
  flex-direction: row;
}
.card-data-title {
  font-weight: 800;
  font-size: 14px;
}
.card-data {
  font-size: 15px;
}

.dts {
  font-weight: bold;
}

.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 5px;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.paymenttext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
